<template>
  <div class="main-content">
    <Header />
    <section class="p-0" v-if="order==''">
      <div class="container">
        <img
          :src='require("@/assets/images/ajax-loader.gif")'
          class="img-fluid bg-img w-100"
        />
      </div>
    </section>
    <!-- thank-you section start -->
    <section class="section-b-space pb-0 shop_content" v-if="order!=''">
      <div class="container">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="delivery-info-text">
              <h2>Thank You!</h2>

<!--              <i class="fa fa-check-circle" aria-hidden="true"></i>-->
<!--              <h3 class="mt-3">{{message}}</h3>-->

              <template v-if="delivery_time">
                <div class="delivery-info">
                  <h3>Expected delivery time</h3>
                  <h2>{{delivery_time}} Minutes</h2>
                  Contact phone# {{contact_phone_number}}
                </div>
              </template>
              <template v-else>
                <template v-if="opening_text">
                  <div class="delivery-info">
                    <h3>{{opening_text}}</h3>
                  </div>
                </template>
              </template>


            </div>
          </div>
          <div class="col-sm-12">
            <div class="text-center mt-3">
              <template v-if="signed_in_as_web_user">

                <template v-if="survey_settings.active === 1 && show_survey_button">
                  <br>
                  <a v-bind:href=survey_settings.survey_url target="_blank">
                    <button class="survey-button-1" @click="survey_button">{{survey_settings.button_text}}</button>
                  </a>
                </template>

                <router-link :to="{ path: '/delivery_map' }">
                  <button class="btn btn-solid checkout-btn success-track-btn" title="Track My Order">Track My Order</button>
                </router-link>

              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Section ends -->
    <section class="section-b-space" v-if="order!=''">
      <div class="container">
        <div class="checkout-page">
          <div class="checkout-form">
              <div class="row" v-for="order in last_order" v-bind:key="order.internal_order_id">
                <div class="col-lg-6 col-sm-12 col-xs-12"  >
                  <div class="checkout-details success-details">
                    <div class="order-box">
                      <div class="title-box pb-0">
                        <div class="text-center">
                          Order# {{order.order_data.ordernumber}}<br>
                          <h6>{{order.order_date_format}}</h6><br>
                        </div>
                      </div>

                      <ul class="qty"  v-if="order.order_data.items.length">
                        <li v-for="(item,index) in order.order_data.items" :key="index">
                          <div class="row">
                            <div class="col-3">
                                <img
                                  :src='item.image_url_small'
                                  class="mr-3 rrr-img w-100"
                                  :alt="item.desc"
                                />
                            </div>
                            <div class="col-9 d-flex align-items-center justify-content-end">
                              <div class="row">
                                <div class="col-12">{{item.qty}} X {{ item.single_price_show_incl_tax }} {{item.discount_qty_amount_show_incl_tax}} = {{item.discounted_qty_price_show_incl_tax}}</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>

                      <table class="sub-total" align="center" v-if="order.order_data.items.length">
                          <tfoot>
                            <tr v-for="tax_web_line in order.order_data.web_total_lines" v-bind:key="tax_web_line.text">

                                <td v-if="tax_web_line.type=='taxesfees'"  v-b-modal="'modal-success-detail'+order.internal_order_id">
                                    {{tax_web_line.text}}
                                </td>
                                <td v-else>{{tax_web_line.text}}</td>
                                <td>
                                <div :style="tax_web_line.style=='crossed'?'text-decoration: line-through;':tax_web_line.style=='bold'?'font-weight: bold;':'font-style: normal;'">{{tax_web_line.value_show}}</div>
                                </td>
                            </tr>

                        </tfoot>

                      </table>

                    </div>
                  </div>


                 <b-modal :id="`modal-success-detail${order.internal_order_id}`" size="md" centered hide-footer >
                    <template v-slot:modal-title>{{webTotalTitle}}</template>
                    <table align="center">
                      <th>
                        <tr>
                          <td><strong>{{webTotalTitle}}</strong></td>
                        </tr>
                      </th>
                      <tbody>
                        <tr>
                          <td><strong>Detail</strong></td>
                          <td><strong>description</strong></td>
                          <td><strong>Price</strong></td>

                        </tr>
                        <tr v-for="tax_web_detail in order.order_data.web_total_details" v-bind:key="tax_web_detail.text">
                          <td>{{tax_web_detail.text}}</td>
                          <td>{{tax_web_detail.description}}</td>
                          <td>{{tax_web_detail.value_show}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </b-modal>
                  <div class="col-sm-12 empty-cart-cls text-center" v-if="!order.order_data.items.length">
                    <img :src='"@/assets/images/icon-empty-cart.png"' class="img-fluid" alt="empty cart" />
                    <h3 class="mt-3">
                      <strong>Your history is Empty</strong>
                    </h3>
<!--                    <h4 class="mb-3">Add something to make me happy :)</h4>-->
                    <div class="col-12">
                      <router-link :to="{ path: '/shop'}" class="btn btn-solid">Shop</router-link>
                    </div>
                  </div>

                </div>
                <div class="col-lg-6">
                  <div class="row order-success-sec">

                    <template v-if="order.order_data.is_drive_trough">

                      <div class="col-sm-12">
                        <h4>Drive Trough Address</h4>
                        <ul class="order-detail">
                          <li class="overflow-hidden">{{order.delivery_address.company}}</li>
                          <li class="overflow-hidden">{{order.delivery_address.address1}}</li>
                          <li class="overflow-hidden">{{order.delivery_address.city}}, {{order.delivery_address.state}} {{order.delivery_address.zip}}</li>
                        </ul>
                      </div>
                    </template>

                  <template v-else>
                    <div class="col-sm-12" v-if="order.order_data.is_pickup">
                      <h4>Pickup Address</h4>
                      <ul class="order-detail">
                          <li class="overflow-hidden">{{order.delivery_address.company}}</li>
                          <li class="overflow-hidden">{{order.delivery_address.address1}}</li>
                          <li class="overflow-hidden">{{order.delivery_address.city}}, {{order.delivery_address.state}} {{order.delivery_address.zip}}</li>
                      </ul>
                    </div>
                    <div class="col-sm-12" v-else>
                      <h4>Delivery Address</h4>
                      <ul class="order-detail">
                        <li class="overflow-hidden">{{order.delivery_address.firstname}} {{order.delivery_address.lastname}}</li>
                        <li class="overflow-hidden">{{order.delivery_address.address1}}</li>
                        <li class="overflow-hidden">{{order.delivery_address.city}}, {{order.delivery_address.state}} {{order.delivery_address.zip}}</li>
                        <li class="overflow-hidden" v-if="order.order_data.is_pickup">{{order.delivery_address.phone}}</li>
                      </ul>
                    </div>

                    <div class="col-sm-12 payment-mode">
                      <h4>payment method</h4>
                      <p>{{order.order_data.payment_type === 1 ? "Debit Card" : "Cash"}}</p>
                    </div>

                    <div class="col-md-12"  v-if="order.order_data.is_pickup">
                      <div class="delivery-sec">
                        <h3>Order ready for pickup in</h3>
                        <h2>15 Minutes</h2>
                      </div>
                    </div>
                    <div class="col-md-12" v-else>





<!--                      <div class="delivery-sec">-->
<!--                        <h3>Expected delivery time</h3>-->
<!--                        <h2>{{order.order_data.web_delivery_estimate}}</h2>-->
<!--                      </div>-->

<!--                      delivery_time: 'cart/delivery_time',-->
<!--                      contact_phone_number: 'cart/contact_phone_number',-->
<!--                      opening_text: 'cart/opening_text',-->



                    </div>
                    </template>

                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section ends -->
    <Footer />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import Header from '@/components/header'
import Footer from '@/components/footer'
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      show_survey_button: true,
      orderid: null,
    }
  },
  computed: {
    ...mapState({
      order_id: state=>state.cart.order_id,
      app_link: state=>state.cart.app_link,
      message: state=>state.cart.message,
      last_order: state=>state.cart.last_order,
    }),
    ...mapGetters({
      order: 'cart/ordered',
      getDetail: 'products/getProductByProductId',
      webTotalTitle: 'cart/webTotalTitle',
      signed_in_as_web_user:'auth/webUserAuthed',
      survey_settings: 'cart/survey_settings',

      delivery_time: 'cart/delivery_time',
      contact_phone_number: 'cart/contact_phone_number',
      opening_text: 'cart/opening_text',

    })
  },
  methods: {
    survey_button() {
      this.show_survey_button = false;
      this.orderid = this.last_order[0].internal_order_id;
      this.$store.dispatch('auth/surveyButtonClicked',{type: 'CHECKOUT', orderid: this.orderid});
    },
  }
}
</script>


<style scoped>

.delivery-info {
  padding: 30px;
  text-align: center;
  margin-top: 20px;
  background-color: #f9f9f9;
}

.delivery-info-text {
  text-align: center;
}



.survey-button-1 {
  background-color: #16CB02;
  color: black;
  width: 100%;
  padding: 6px;
  border-radius: 8px;
  font-size: 18px;
  border-style: none;
  margin-bottom: 30px;
}

</style>
